export default "__VITE_ASSET__01e4a97b__"